/**
 * @export
 * @class SendLog
 * GA 로그 전송을 관리
 */
export default class SendLog {
  constructor() {
    this.setEvent();
  }

  setEvent() {
    $('.app_header_ui_wrap .bt').on('click', e => {
      this.sendGA(e);
    });
    $('body').on('click', '[data-tlarea]', e => {
      this.clickItem(e);
    });
  }

  clearEvent() {
    $('.app_header_ui_wrap .bt').off('click');
    $('body').off('click', '[data-tlarea]');
  }

  clickItem(e) {
    const wel = $(e.currentTarget);
    this.mergeLog(
      e,
      {
        'tl:area': wel.attr('data-tlarea'),
        'tl:ord': wel.attr('data-tlord'),
        'tl:dimension': wel.attr('data-tldimension'),
      },
      false
    );
  }

  sendGA(e) {
    const wel = $(e.currentTarget);
    this.mergeLog(
      e,
      {
        'tl:area': wel.attr('tl:area'),
        'tl:ord': wel.attr('tl:ord'),
      },
      true
    );
  }

  sendGAByParam(sTlArea, sTlOrd) {
    this.mergeLog(
      null,
      {
        'tl:area': sTlArea,
        'tl:ord': sTlOrd,
      },
      true
    );
  }

  update(sStorageKey) {
    if (sStorageKey === 'sendGAByParam') {
      const htGA = TMON.oApp.htStorage.sendGAByParam;
      this.sendGAByParam(htGA.sTlArea, htGA.sTlOrd);
    }
  }

  mergeLog(e, htTl, bSendOnlyGA) {
    let areaName = 'MW_AreaTrack'; // Mobile Web
    if (TMON.sDevice === 'MI') {
      // IOS App
      areaName = 'IOS_AreaTrack';
    } else if (TMON.sDevice === 'MA') {
      // Android App
      areaName = 'AD_AreaTrack';
    } else if (TMON.sDevice === 'PW') {
      // PC Web
      areaName = 'PW_AreaTrack';
    }

    const aEvent = [
      areaName,
      'click',
      `{${htTl['tl:area']}}.{${htTl['tl:ord']}}`,
      {
        dimension03: TMON.oApp.htStorage.htStaticData.htCategoryInfo.sDepth1No,
        dimension04: TMON.oApp.htStorage.htStaticData.htCategoryInfo.sDepth2No,
        dimension05: TMON.oApp.htStorage.htStaticData.htCategoryInfo.sDepth3No,
        dimension41: TMON.oApp.htStorage.htStaticData.htCategoryInfo.sDepth4No,
        dimension07: TMON.oApp.htStorage.htStaticData.htCategoryInfo.sCurrent,
        dimension08: TMON.oApp.htStorage.htStaticData.sDealNo,
      },
    ];

    try {
      if (bSendOnlyGA) {
        window.gaSendEvent(...aEvent);
      } else {
        TMON.sendLog(aEvent, [e.currentTarget, e, htTl]);
      }
    } catch (error) {
      // console.log(error);
    }
  }
}
